<template lang="pug">
.skeleton-external-rights-container
  .skeleton-external-rights-title.skeleton-animate
  .skeleton-external-rights-tabs-wrapper
  .skeleton-external-rights-content
    .skeleton-external-rights-content-item(v-for="n in 9" :key="n")
      .skeleton-item-right-img.skeleton-animate
      .skeleton-item-right-middle
      .skeleton-item-right-btn.skeleton-animate
  .skeleton-external-rights-more.skeleton-animate
</template>

<script>
export default {
  name: 'ExternalRightsSkeleton',
  props: {},
};
</script>

<style lang="less" scoped>
.skeleton-external-rights-container {
  background: #fff;
  margin: 0.1rem 0.12rem;
  padding: 0.14rem 0 0.19rem 0;
  border-radius: 0.16rem;

  .skeleton-external-rights-title {
    width: 1.36rem;
    height: 0.22rem;
    border-radius: 0.06rem;
    background: #f0f3f5;
    margin-left: 0.15rem;
    position: relative;
  }

  .skeleton-external-rights-tabs-wrapper {
    margin: 0.16rem auto 0 auto;
    width: 3.31rem;
    height: 0.18rem;
    border-radius: 0.06rem;
    opacity: 0.6;
    background: #f0f3f5;
  }

  .skeleton-external-rights-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.08rem;
    padding: 0.16rem 0.1rem 0;

    .skeleton-external-rights-content-item {
      padding-bottom: 0.06rem;
      width: 1.05rem;
      height: 1.29rem;
      border: 0.01rem solid #f0f3f5;
      border-radius: 0.12rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .skeleton-item-right-img {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 0.08rem;
        margin-top: 0.1rem;
        background: #f0f3f5;
      }

      .skeleton-item-right-middle {
        width: 0.83rem;
        height: 0.26rem;
        border-radius: 0.08rem;
        opacity: 0.6;
        background: #f0f3f5;
        margin-top: 0.06rem;
      }

      .skeleton-item-right-btn {
        width: 0.6rem;
        height: 0.23rem;
        border-radius: 0.06rem;
        background: #f0f3f5;
        margin-top: 0.08rem;
      }
    }
  }

  .skeleton-external-rights-more {
    width: 1.06rem;
    height: 0.27rem;
    border-radius: 0.36rem;
    background: #f0f3f5;
    margin: 0 auto;
    margin-top: 0.16rem;
  }
}

// 扫光动画样式
.skeleton-animate {
  position: relative;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent);
    animation: skeleton-shine 1.5s infinite;
  }
}

@keyframes skeleton-shine {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
